module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAYAAAA6GuKaAAAACXBIWXMAABYlAAAWJQFJUiTwAAABHklEQVRYhe2Y3Q2CMBRGP4kDMIIjOII+MICTGCbwOoErOALvfdARGMERnKAxmsaQ0j8ULoj3PN4Wcgpfb5NCEGbGIrScrKAcwHqMJWtFV9+YVzoriAAcBrOKcwdQakXnJOkJCDfZaUVVs5B5Ju5ZtcKc7NGWdFbQBkA+vuublV1YpjylFQU3bJ+Yj3YJvdIXj0nzk9JJ8eiCq7eHeu4kpI2wncle94RkmguR5qLzRuToDjE+6R6Dd4cYkmkuRJqLIY7xIH10H3bpPrqPZJoLkeZCpLn4j8PFHATevvrteAoSDy6S4mGuqriI3oe7pO+OWvBujZtWPLSiGsBtQo6VXfBluhzeJYnnXz/aE53S5uZ9C6AeUfjlYP68IMwXAA/8gT6kFdaZCAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/65.png
// module id = 4Xkc
// module chunks = 1